import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
import { CatLayoutContainer } from '@blocks-react/components/LayoutContainer';
import styles from './HeaderRow.module.scss';
export const HeaderRow = ({ children }) => (_jsx(CatLayoutContainer, { children: _jsx("div", { className: cx(styles['shopping_cart'], 'd-flex align-items-center justify-content-between', styles['header-row']), children: children }) }));
